import type { Slicer } from '@swf/core/store';

import type { SportsMenuState } from './types';

export const selectors = (slice: Slicer<SportsMenuState>) => ({
  az: () => slice((state) => state.az),
  azErrorCode: () => slice((state) => state.azErrorCode),
  popular: () => slice((state) => state.popular),
  hasPreloaded: () => slice((state) => state.preloaded),
  links: () => slice(({ search }) => search.links),
  selectedEventTypeId: () => slice(({ search }) => search.selectedEventTypeId),
  searchQuery: () => slice(({ search }) => search.query),
  searchResults: () => slice(({ search }) => search.results),
  isFetchingSearch: () => slice(({ search }) => search.isFetching),
  isNewSearchQuery: () => slice(({ search }) => search.isNewSearchQuery)
});
